// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"dropdown-3bn_7","bottom-left":"bottom-left-2vzJl dropdown-3bn_7","top-left":"top-left-2Jjgt dropdown-3bn_7","middle-right":"middle-right-1J3jf dropdown-3bn_7","middle-left":"middle-left-1oTgF dropdown-3bn_7"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/tethers/dropdown.scss
 ** module id = 43
 ** module chunks = 0
 **/